import { Col, Row, Section } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function HeroSectionIntervention({ ...props }) {
	const { account, language } = useContext(CoreAdoptionContext)
	return (
		<Section id={formatSectionId(props)} className="scroll-mt-14">
			<div className="absolute top-0 left-0 z-0 h-full w-full bg-cover bg-no-repeat opacity-75" style={{ backgroundImage: 'url(/images/arc-core/books-bg.jpg)' }}>
				<div className="white-transparent-gradient-strong h-full w-full"></div>
			</div>
			<Row center className="relative z-10 pt-10 sm:pt-20">
				<></>
			</Row>
			<Row center className="relative z-10 mt-32">
				<Col width="w-full md:w-5/6 xl:w-2/3">
					<span className="block text-center text-2xl font-bold leading-tight text-ab-100 md:text-3xl lg:text-5xl">{account?.name}</span>
					<span className="block text-center text-2xl font-medium leading-tight md:text-3xl lg:text-4xl">Intervention Aligned to the Science of Reading</span>
					<p className="mt-6 text-left text-lg sm:mt-12 sm:text-center sm:text-xl">
						Whether your school uses ARC Core<sup>®</sup> or another high-quality ELA program, there are always students who need additional support to become
						successful readers. ARC provides multiple intervention solutions for different grade levels that provide the perfect blend of direct instruction and
						differentiated support. These programs can be used in class during the intervention block, after school, and in summer tutoring.
					</p>
				</Col>
			</Row>
		</Section>
	)
}
